export class AnimationRequest
{
  private handle: number = undefined;

  public schedule(step: (now: number) => void): void
  {
    if (this.handle !== undefined) {
      return;
    }

    this.handle = window.requestAnimationFrame((now) => {
      this.handle = undefined;
      step(now);
    });
  }

  public cancel(): void
  {
    if (this.handle === undefined) {
      return;
    }

    window.cancelAnimationFrame(this.handle);
    this.handle = undefined;
  }
}
